// Special Pricing on term vendors (e.g. SMC Software Only) stores software
// price as a per-TB, per-term unit price — but sales still thinks in the
// familiar $/10TB/month figure. These helpers convert between the two.
//
// familiarScale is 1 on classic (non-term) vendors, so familiarToUnit /
// unitToFamiliar are the identity there — Special Pricing behaves exactly as
// before for AIC/DELL.
//
// $/10TB/month (the unit sales thinks in) <-> stored per-TB-per-term unit price.
// familiarScale is 1 on classic vendors, months/10 on term vendors.
export const familiarScale = (swModel, subscriptionMonths) =>
  swModel.termBased ? subscriptionMonths / 10 : 1;

export const familiarToUnit = (familiar, swModel, months) =>
  Number((familiar * familiarScale(swModel, months)).toFixed(2));

export const unitToFamiliar = (unit, swModel, months) =>
  Number((unit / familiarScale(swModel, months)).toFixed(2));

// For displaying a value loaded from a saved config (e.g. a loaded quote's
// ssdSoftware/hddSoftware) in the Special Pricing inputs. Term vendors need
// the unit->familiar conversion; classic vendors must show the EXACT saved
// value untouched — unitToFamiliar's .toFixed(2) is a no-op for well-formed
// prices but would still round away extra precision if it were ever present,
// which is a behavior change classic-vendor load display must not have.
export const loadedValueToFamiliar = (unit, swModel, months) =>
  swModel.termBased ? unitToFamiliar(unit, swModel, months) : unit;
